module.exports = __webpack_public_path__ + "static/sport/loading.19f6dad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/loading.gif
// module id = EQQn
// module chunks = 0